import 'dayjs/locale/id';
import React from 'react';
import Select from '../../fields/SelectBox/Select';
import IconUpDownArrow from '../../icons/IconUpDownArrow';
import styles from './styles.scoped.css';

export const initialValues = {
  regional: '',
  provinceId: '',
  cityId: '',
  districtId: '',
  villageId: '',
};

export const Fields = ({
  values = initialValues,
  handleChangeValues,
  handleSearchFilter,
  dropdownData,
  regionalId,
}) => {
  return [
    {
      label: 'Regional',
      disabled: regionalId !== '',
      component: (
        <Select
          data={dropdownData.regional}
          eventName="regional"
          hideLabel
          name="regional"
          onChangeSelect={(value) => handleChangeValues({ name: 'regional', value })}
          placeholder="Pilih Regional"
          rightSection={<IconUpDownArrow />}
          valueForm={values.regional || regionalId}
        />
      ),
    },
    {
      label: 'Provinsi',
      // disabled: provinceId !== '',
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.provinces}
          eventName="provinces"
          hideLabel
          name="provinceId"
          onChangeSelect={(value) => handleChangeValues({ name: 'provinceId', value })}
          placeholder="Pilih Provinsi"
          rightSection={<IconUpDownArrow />}
          valueForm={values.provinceId}
        />
      ),
    },
    {
      label: 'Kota/Kab',
      // disabled: JSON.stringify(cities)?.length === 40,
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.cities}
          debounce={true}
          eventName="cities"
          hideLabel
          name="cityId"
          onChangeSelect={(value) => handleChangeValues({ name: 'cityId', value })}
          onSearchChange={handleSearchFilter}
          placeholder="Pilih Kota/Kab"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          valueForm={values.cityId}
        />
      ),
    },
    {
      label: 'Kecamatan',
      // disabled: values.cityId?.length === 2 || values.cityId?.length === 0,
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.districts}
          debounce={true}
          eventName="districts"
          hideLabel
          name="districtId"
          onChangeSelect={(value) => handleChangeValues({ name: 'districtId', value })}
          onSearchChange={handleSearchFilter}
          placeholder="Pilih Kecamatan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          valueForm={values.districtId}
        />
      ),
    },
    {
      label: 'Kelurahan',
      // disabled: values.districtId === undefined,
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.villages}
          debounce={true}
          eventName="villages"
          hideLabel
          name="villageId"
          onChangeSelect={(value) => handleChangeValues({ name: 'villageId', value })}
          onSearchChange={handleSearchFilter}
          placeholder="Pilih Kelurahan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          valueForm={values.villageId}
        />
      ),
    },
    {
      label: 'Status',
      // disabled: values.districtId === undefined,
      component: (
        <Select
          className={styles.cusField}
          data={dropdownData.status}
          debounce={true}
          eventName="activationStatus"
          hideLabel
          name="isRegisterSubPangkalan"
          onChangeSelect={(value) => handleChangeValues({ name: 'isRegisterSubPangkalan', value })}
          // onSearchChange={handleSearchFilter}
          placeholder="Pilih Status"
          rightSection={<IconUpDownArrow />}
          // searchable={true}
          valueForm={values.isRegisterSubPangkalan}
        />
      ),
    },
  ];
};
